<template>
  <div class="change-password">
    <Busy :value="busy"></Busy>
    <v-container
      class="d-flex align-center justify-center"
      fluid
      fill-height
      @mousedown.stop
      @keydown.stop
    > <!-- The .stops prevent the App.vue keepalives from firing on this page since we are not in a session yet -->      
      <template v-if="state === 'normal'">
        <v-card class="change-password__card elevation-12 align-self-center justify-self-center">
          <v-card-title>
            Change password
          </v-card-title>
          <v-card-text>
            <PasswordForm
              ref="form"
              :username="this.email"
              usernameLabel="email"
            >            
            </PasswordForm>
            <br/>
            <v-row>
              <v-col cols="12">
                <v-btn
                  class="action-button"
                  color="primary"
                  @click="changePassword"
                >
                  Change password
                </v-btn>
              </v-col>
              <v-col cols="12" class="d-flex justify-center">
                Here by mistake?&nbsp;<router-link to="/signin">Sign in</router-link>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
      <template v-else-if="state === 'success'">        
        <v-row>
          <v-col cols="12" class="text-center">
            <p class="text-h4 py-4">
              <v-icon left size="64" class="pr-1" color="success">fa-solid fa-circle-check</v-icon>
              Success!
            </p>
            <p class="text-h5 py-4">Your password has been reset successfully! You may now&nbsp;<router-link to="/signin">sign in</router-link> with your new password.</p>
            <p class="text-h5 py-4">Automatically redirecting to the sign-in page in {{countDown}} seconds.</p>
          </v-col>
        </v-row>
      </template>
      <template v-else-if="state === 'invalid'">
        <v-row>
          <v-col cols="12" class="text-center">
            <p class="text-h3 py-4">
              <v-icon left size="64" class="pr-1" color="error">fa-solid fa-circle-exclamation</v-icon>
              Error!
            </p>
            <p class="text-h5 py-4">The password reset link is not valid.</p>
            <p class="text-h5 py-4">Go&nbsp;<router-link to="/forgot">here</router-link> to get a new link.</p>
          </v-col>
        </v-row>
      </template>
    </v-container>
  </div>
</template>

<script>
import { Busy, PasswordForm } from '@itus/ui.common'

export default {
  name: 'ChangePassword',
  data() {
    return {
      busy: false,
      resetPasswordId: null,
      email: null,
      state: 'normal',
      countDown: 10,
      countDownTimer: null
    }
  },
  components: {
    Busy,
    PasswordForm
  },
  methods: {
    async changePassword() {
      if (!this.$refs.form.validate())
        return    

      let body = {
        email: this.email,
        password: this.$refs.form.newPassword,
        resetId: this.resetPasswordId
      }

      try {
        this.busy = true
        await this.$store.dispatch('resetPassword', body)
        this.state = 'success'
        this.countDown = 10
        this.countDownTimer = setInterval(this.decrement, 1000)
      } catch {
        this.state = 'invalid'
      } finally {
        this.busy = false
      }
    },
    decrement() {
      this.countDown = this.countDown - 1
      if(this.countDown <= 0) {
        if(this.countDownTimer)
          clearInterval(this.countDownTimer)
        
        this.$router.push('/signin')
      }        
    }
  },
  async mounted() {
    this.resetPasswordId = this.$route.query?.id
    this.email = this.$route.query?.email ? atob(this.$route.query?.email) : null  

    this.countDown = 10
    this.countDownTimer = null

    if(this.$store.getters.isLoggedIn)
      await this.$store.dispatch('logout')
  }
}
</script>
<style lang="scss" scoped>
.change-password {
  height: 100%
}
.change-password__alert {
  position: fixed;
  width: 100%;
  z-index: 1;
}
.change-password__card {
  max-width: 450px;
}
.action-button {
  width: 100%;
}
</style>